/**
 * Décorateur pour debouncer une méthode (attend l'inactivité avant d'exécuter)
 * @param delay Délai en ms
 */
export function Debounce(delay: number) {
	return function(target: any, propertyKey: string | symbol, descriptor: PropertyDescriptor): PropertyDescriptor {
		const originalMethod = descriptor.value;
		let timer: number | undefined;

		descriptor.value = function(...args: any[]): void {
			if (timer) {
				clearTimeout(timer);
			}

			// Capturer les arguments et le contexte du dernier appel
			const capturedArgs = [...args];
			const capturedThis = this;

			timer = window.setTimeout(() => {
				originalMethod.apply(capturedThis, capturedArgs);
				timer = undefined;
			}, delay);
		};

		return descriptor;
	};
}



// WEBPACK FOOTER //
// ./src/shared/services/debounce.service.ts